import { useEffect } from 'react';

import { Typography } from '@mui/material';
import { useField } from 'formik';
import { BiPlus } from 'react-icons/bi';

import { Card, InvoiceLineItem } from 'src/components';
import { Flex } from 'src/components/Flex';
import { OptionTypes } from 'src/components/FormikComponents/DropDown';

import { INITIAL_CREDIT_NOTE_ITEM } from '..';

const CREDIT_NOTE_ITEMS_FIELD_NAME = 'creditNoteItems';

interface CreditNoteItemProps {
    ledgerAccounts: OptionTypes[];
}

const CreditNoteItem = ({ ledgerAccounts }: CreditNoteItemProps) => {
    const [{ value: creditNoteItems }, _, { setValue: setCreditNoteItems }] = useField(
        CREDIT_NOTE_ITEMS_FIELD_NAME
    );
    const [{ value: isInvoiceSelected }] = useField('isInvoiceSelected');

    useEffect(() => {
        if (creditNoteItems.length === 0) {
            setCreditNoteItems([INITIAL_CREDIT_NOTE_ITEM]);
        }
    }, [creditNoteItems, setCreditNoteItems]);

    const onAddCreditNoteItem = () => {
        setCreditNoteItems([...creditNoteItems, INITIAL_CREDIT_NOTE_ITEM]);
    };

    const removeItem = (index) => {
        if (creditNoteItems.length > 1) {
            const updatedItems = creditNoteItems.filter((_, i) => {
                return i !== index;
            });
            setCreditNoteItems(updatedItems);
        }
    };

    return (
        <Card gap="36px">
            <Flex alignItems="center" justifyContent="space-between">
                <Typography fontSize="20px" fontWeight="500" lineHeight="30px" color="#1d1d1b">
                    Credit Note Items
                </Typography>
                {!isInvoiceSelected && (
                    <Flex gap="8px">
                        <Flex
                            padding="6px"
                            onClick={onAddCreditNoteItem}
                            sx={{ cursor: 'pointer' }}
                            bgcolor="black"
                            color="white"
                            borderRadius="4px"
                            data-testid="add-line-item"
                        >
                            <BiPlus size="14px" />
                        </Flex>
                    </Flex>
                )}
            </Flex>

            {creditNoteItems.map((item, index) => {
                const descriptionPart = item.description ? item.description.substring(0, 10) : '';
                return (
                    <InvoiceLineItem
                        key={`${index}-${descriptionPart}`}
                        index={index}
                        ledgerAccounts={ledgerAccounts}
                        formNamePrefix={CREDIT_NOTE_ITEMS_FIELD_NAME}
                        removeItem={index > 0 ? removeItem : undefined}
                        isInvoiceSelected={isInvoiceSelected}
                    />
                );
            })}
        </Card>
    );
};

export default CreditNoteItem;
